import { render, staticRenderFns } from "./HomefitStoryV2.vue?vue&type=template&id=1cba4ffc&scoped=true&"
import script from "./HomefitStoryV2.vue?vue&type=script&lang=js&"
export * from "./HomefitStoryV2.vue?vue&type=script&lang=js&"
import style0 from "./HomefitStoryV2.vue?vue&type=style&index=0&id=1cba4ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba4ffc",
  null
  
)

export default component.exports